import { toast } from "sonner";

export async function crearAdditionalPayments(data) {
    const token = sessionStorage.getItem('token'); // Retrieve the JWT token from session storage
    const headers = {
        'Authorization': `Bearer ${token}`, // Pass the token in the Authorization header
        'Content-Type': 'application/json'
    };
    const postUrl = `${process.env.REACT_APP_API_URL}/admin/profesor/pago-adicional/crear`;

    try {
        const postResponse = await fetch(postUrl, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data) // Convert the time value data to JSON
        });

        const contentType = postResponse.headers.get('content-type');
        const responseText = await postResponse.text(); // Read the response as text

        if (!postResponse.ok) {
            console.error('Server responded with:', responseText);
            throw new Error('Failed to create time value');
        }

        if (contentType && contentType.includes('application/json')) {
            toast.success("Successfully created additional payment");
            return JSON.parse(responseText); // Attempt to parse the response as JSON
        } else {
            console.log('Response is not JSON:', responseText);
            toast.success("Successfully created additional payment");
            return { message: responseText }; // Return the response text as a message
        }

    } catch (error) {
        toast.error("Error creating additional payment: " + error.message);
        throw new Error(`Failed to create additional payment: ${error.message}`);
    }
}